import matchCondition from './matchCondition.js'

/**
 * Generic in-record guard: assert something about the record itself, with no
 * database round trip. The condition describes the state required for the
 * operation to be ALLOWED.
 *
 *   { operation: 'checkField', condition: { field: 'inventory', operator: 'empty' } }
 *   { operation: 'checkField', conditions: [ { field: 'totalProducts', operator: 'lte', value: 0 },
 *                                            { field: 'inventory',     operator: 'empty' } ] }
 *
 * Use this ahead of any `noReferences` rule in a guard list: it is free, and
 * runValidationLogic stops at the first failure, so the cheap check short-circuits
 * the expensive ones.
 *
 * `emptyArray` is an alias over this.
 */
const checkField = (condition, data, conditions) => {
    const list = conditions || (condition ? [condition] : [])
    if (!list.length) {
        console.warn('<checkField> no condition supplied')
        return { valid: false }
    }

    const failed = list.find(c => !matchCondition(data, c, data))
    return failed ? { valid: false, failed } : { valid: true }
}

export default checkField
